import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule, JsonpModule } from '@angular/http';
import { ApiService } from '.';
export class ApiModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    HttpModule,
    JsonpModule
  ],
  providers: [ApiService],
  declarations: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ApiModule_tsickle_Closure_declarations() {
/** @type {?} */
ApiModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ApiModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
